import { createContext, useContext } from "react";

export type SearchBoxContextValue = {
  /** Current input value. */
  term: string;
  setTerm: (term: string) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  /** Close the dropdown and search for `term`. */
  submit: (term: string) => void;
  isSubmitting: boolean;
};

const SearchBoxContext = createContext<SearchBoxContextValue | null>(null);

export const SearchBoxContextProvider = SearchBoxContext.Provider;

/**
 * Interaction state only — deliberately no data.
 *
 * Sections (recents, suggestions, …) fetch or read what they render themselves, so one can be added,
 * removed or reordered without touching the root, the panel or a sibling.
 */
export const useSearchBoxContext = (): SearchBoxContextValue => {
  const value = useContext(SearchBoxContext);

  if (!value) {
    throw new Error("useSearchBoxContext must be used within <SearchBox.Root>");
  }

  return value;
};
